import { createSlice } from "@reduxjs/toolkit";
import { getInvoicesList, deleteInvoice } from "./Invoices.thunk";

const baseState = {
  invoicesList: [],
  client_info_id: null,
  page: 1,
  pageSize: 5,
  totalPages: 0,
  totalRecords: 0,
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusDelete: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  errorDelete: null,
};

const initialState = {
  ...baseState,
};

export const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    setClientInfoId: (state, action) => {
      state.client_info_id = action.payload;
    },
    ResetStore: (state) => {
      state = { ...baseState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoicesList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getInvoicesList.fulfilled, (state, action) => {
        const { invoicesList, page, page_size, total_pages, total_records } =
          action.payload;
        state.status = "succeeded";
        state.invoicesList = invoicesList;
        state.page = page;
        state.pageSize = page_size;
        state.totalPages = total_pages;
        state.totalRecords = total_records;
        state.error = null;
      })
      .addCase(getInvoicesList.rejected, (state, action) => {
        state.status = "failed";
        state.invoicesList = [];
        state.page = 1;
        state.pageSize = 5;
        state.totalPages = 0;
        state.totalRecords = 0;
        state.error =
          action?.payload?.message || "Error fetching invoices list";
      });
    builder
      .addCase(deleteInvoice.pending, (state) => {
        state.statusDelete = "loading";
        state.errorDelete = null;
      })
      .addCase(deleteInvoice.fulfilled, (state) => {
        state.statusDelete = "succeeded";
        state.errorDelete = null;
      })
      .addCase(deleteInvoice.rejected, (state, action) => {
        state.statusDelete = "failed";
        state.errorDelete =
          action?.payload?.message || "Error deleting invoice";
      });
  },
});

export const { setClientInfoId, ResetStore } = invoicesSlice.actions;

export default invoicesSlice.reducer;
